import React, { createContext, ReactNode, useContext, useMemo, useState } from 'react';
import { ConsentCheckboxState } from '../../../../utilities/marketing-consent';

export type CreateAccountConfirmationPageContextProps = {
  privacyPolicyText?: string;
  setPrivacyPolicyText: (text: string) => void;

  marketingConsent?: ConsentCheckboxState;
  setMarketingConsent: (state: ConsentCheckboxState) => void;
};

export const CreateAccountConfirmationPageContext =
  createContext<CreateAccountConfirmationPageContextProps | null>(null);

export const useCreateAccountConfirmationPageContext =
  (): CreateAccountConfirmationPageContextProps => {
    const context = useContext(CreateAccountConfirmationPageContext);

    if (!context) {
      throw new Error(
        'useCreateAccountConfirmationPageContext must be used within a CreateAccountConfirmationPageContext provider'
      );
    }

    return context;
  };

export const CreateAccountConfirmationPageProvider = ({ children }: { children: ReactNode }) => {
  const [privacyPolicyText, setPrivacyPolicyText] = useState<undefined | string>();
  const [marketingConsent, setMarketingConsent] = useState<ConsentCheckboxState>({
    state: 'not_shown',
  });

  const state = useMemo(
    (): CreateAccountConfirmationPageContextProps => ({
      privacyPolicyText,
      setPrivacyPolicyText,
      marketingConsent,
      setMarketingConsent,
    }),
    [marketingConsent, privacyPolicyText]
  );

  return (
    <CreateAccountConfirmationPageContext.Provider value={state}>
      {children}
    </CreateAccountConfirmationPageContext.Provider>
  );
};
